<template>
  <div>
    <b-sidebar
      @hidden="hidden()"
      :ref="'sim_sidebar'"
      :visible="$store.state.show_sim_details_popup"
      backdrop
      shadow
      id="sim_details_sidebar"
      :title="get_title()"
      :class="'my-sidebar-popup'"
    >
      <div class="">
        <table class="table table-striped">
          <tbody>
            <tr v-for="(field, index) in fields" :key="index">
              <td class="font-weight-bold">{{ field.title }}</td>
              <td v-if="field.field == 'msisdn'">{{ crop_prefix(get_field(field.field)) }}</td>
              <td v-else>{{ get_field(field.field) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  components: {},
  name: "SimCardDetails",
  data: function () {
    return {
      fields: [
        { title: "Numéro", field: "msisdn" },
        { title: "Date d'enregistrement", field: "creation_date" },
        { title: "Nom", field: "first_name" },
        { title: "Prénom", field: "last_name" },
        { title: "Occupation", field: "occupation" },
        { title: "Commune", field: "commune" },
        { title: "Ville", field: "town" },
        { title: "Quartier", field: "area" },
        { title: "Naissance", field: "birth_date" },
        { title: "Lieu Naissance", field: "birth_place" },
        { title: "Pièce", field: "type_label" },
        { title: "N° Pièce", field: "id_number" },
        { title: "Lieu de délivrance", field: "id_issue_place" },
        { title: "Maison", field: "house" },
      ],
    };
  },
  mounted: async function () {},
  methods: {
    get_title: function () {
      if (_.isNull(this.$store.state.core.current_sim_details)) {
        return "";
      }
      return "Infos " + this.crop_prefix(this.$store.state.core.current_sim_details.msisdn);
    },
    hidden: function (el) {
      this.toggle_sim_details_sidebar();
    },
    get_field: function (field) {
      if (_.isNull(this.$store.state.core.current_sim_details)) {
        return "";
      }
      var val = this.$store.state.core.current_sim_details[field];
      val = _.isNull(val) ? "-" : val;
      return val;
    },
  },
};
</script>
<style scoped lang="css">
</style>
